import builder from '../builder';
import RealEstateActionHouseCheck from '../../streamline-icons/light/real-estate-action-house-check.svg';

export default builder(
  'IconRealEstateActionHouseCheckLight',
  RealEstateActionHouseCheck,
);
